import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    UserList,
    CcApprovalLevelList,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
    DashIcon,
} from "client/components"
import {
    Title,
    Author,
    ApprovalLevel,
} from "./styled"

export const HistoryTitle = ({
    history,
}: HistoryProps) => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const levelList = useSelector((state: StoreType) => state.ccApprovalLevel.levelList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const editor = userList[history.editorId]
    const prevUser = userList[history.prevUserId]
    const prevLevel = levelList[history.prevLevelId]

    if (history.systemMessage) {
        return (
            <Title>
                <Author>{editor && `${editor.firstName} ${editor.lastName}`}</Author>
            </Title>
        )
    }

    return (
        <Title>
            <Author>{prevUser && `${prevUser.firstName} ${prevUser.lastName}`}</Author>
            {
                history.parentId === null && ([ // responsible
                    <DashIcon key="dash" />,
                    <ApprovalLevel key="approvalLevel">{lang.author}</ApprovalLevel>,
                ])
            }
            {
                history.parentId !== null && prevLevel && ([ // verifier
                    <DashIcon key="dash" />,
                    <ApprovalLevel key="approvalLevel">{prevLevel.name}</ApprovalLevel>,
                ])
            }
        </Title>
    )
}

export const HistoryTitlePdfExport = (
    history: HistoryType,
    userList: UserList,
    levelList: CcApprovalLevelList,
    lang: LangType,
) => {
    const editor = userList[history.editorId]
    const prevUser = userList[history.prevUserId]
    const prevLevel = levelList[history.prevLevelId]

    if (history.systemMessage) {
        return (
            {
                text: editor ? `${editor.firstName} ${editor.lastName}` : "",
                bold: true,
                margin: [0, 0, 0, 5],
            }
        )
    }

    let approvalLevel: string = null
    if (history.parentId === null) approvalLevel = lang.author
    if (history.parentId !== null && prevLevel) approvalLevel = prevLevel.name

    return (
        {
            text: [
                {
                    text: prevUser ? `${prevUser.firstName} ${prevUser.lastName}` : "",
                    bold: true,
                },
                approvalLevel !== null ? { text: ` — ${approvalLevel}` } : null,
            ],
            margin: [0, 0, 0, 5],
        }
    )
}
